// extracted by mini-css-extract-plugin
export default {"activtyPage_container":"tankSensorEntity_activtyPage_container__ig7pe","container":"tankSensorEntity_container__rQv6U"};